/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S8_HeadingInputs */

const tr_kullanim_s8_heading = /** @type {(inputs: Kullanim_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Güvenlik`)
};

const en_kullanim_s8_heading = /** @type {(inputs: Kullanim_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Security`)
};

const de_kullanim_s8_heading = /** @type {(inputs: Kullanim_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Sicherheit`)
};

const ru_kullanim_s8_heading = /** @type {(inputs: Kullanim_S8_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Безопасность`)
};

/**
* | output |
* | --- |
* | "8. Security" |
*
* @param {Kullanim_S8_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s8_heading = /** @type {((inputs?: Kullanim_S8_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S8_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s8_heading(inputs)
	if (locale === "de") return de_kullanim_s8_heading(inputs)
	if (locale === "ru") return ru_kullanim_s8_heading(inputs)
	return tr_kullanim_s8_heading(inputs)
});